import React, { createContext, useContext, useEffect, useState } from 'react';
import socket from '../services/socket';

const SocketContext = createContext();

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};

export const SocketProvider = ({ children }) => {
  const [isConnected, setIsConnected] = useState(false);
  const [clientCount, setClientCount] = useState(0);

  useEffect(() => {
    // Handle connection
    socket.on("connect", () => {
      setIsConnected(true);
    });

    // Handle disconnection
    socket.on("disconnect", () => {
      setIsConnected(false);
    });

    // Handle connection errors
    socket.on("connect_error", (error) => {
      setIsConnected(false);
    });

    // Handle client count updates
    socket.on("clients", (data) => {
      setClientCount(data.clients);
    });

    // Check initial connection status
    setIsConnected(socket.connected);

    // Cleanup on unmount
    return () => {
      socket.off("connect");
      socket.off("disconnect");
      socket.off("connect_error");
      socket.off("clients");
    };
  }, []);

  const value = {
    isConnected,
    clientCount,
    socket
  };

  return (
    <SocketContext.Provider value={value}>
      {children}
    </SocketContext.Provider>
  );
};
